import React, { FC } from 'react';
import { CaptureRevisedBudgetPromptProps } from './CaptureRevisedBudgetPromptProps';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { IconButton, Stack } from '@mui/material';
import Select, { Option } from '@ingka/select';
import SSRIcon from '@ingka/ssr-icon';
import cross from '@ingka/ssr-icon/paths/cross';
import skapaColours from '@ingka/variables/colours-css';

const CaptureRevisedBudgetPrompt: FC<CaptureRevisedBudgetPromptProps> = ({
  isVisible,
  onClose,
  onCancel,
  onAccept,
  selectedFY,
  onFYChange,
  fyOptions,
}) => {
  return (
    <Modal
      handleCloseBtn={onClose}
      visible={isVisible}
      data-testid={'capture-revised-budget-modal'}
    >
      <Prompt
        aria-label="Accessibility header for a modal"
        className="example-prompt-override"
        header={null}
        titleId={'capture-revised-budget-modal-title'}
        footer={
          <ModalFooter>
            <Stack direction={'row'} spacing={2} width={'100%'}>
              <Button
                style={{ marginBottom: 0 }}
                text={'Cancel'}
                data-testid={'capture-revised-budget-cancel'}
                type="secondary"
                onClick={onCancel}
              />
              <Button
                text={'Capture budget baseline'}
                data-testid={'capture-revised-budget-accept'}
                type="primary"
                onClick={onAccept}
                disabled={!selectedFY}
              />
            </Stack>
          </ModalFooter>
        }
        title={
          <Stack direction={'row'} justifyContent={'space-between'} pt={3}>
            <Stack flex={1}>Capture revisit budget baseline</Stack>
            <IconButton
              onClick={onClose}
              sx={(theme) => ({
                position: 'absolute',
                top: theme.spacing(2),
                right: theme.spacing(2),
              })}
            >
              <SSRIcon paths={cross} />
            </IconButton>
          </Stack>
        }
      >
        <Stack spacing={2}>
          <p>
            Select the FYs you want to capture the budget baseline for the
            selected projects
          </p>
          <Select
            id={'capture-revised-budget-fy-selector'}
            data-testid={'capture-revised-budget-fy-selector'}
            label={'FY'}
            hintText={'Choose an FY'}
            value={selectedFY}
            style={{ color: skapaColours.colourNeutral7 }}
            onChange={(e) => onFYChange(e.target.value)}
          >
            {fyOptions.map((fy) => (
              <Option key={fy} value={fy} name={fy} />
            ))}
          </Select>
        </Stack>
      </Prompt>
    </Modal>
  );
};

export default CaptureRevisedBudgetPrompt;
